import { motion } from "framer-motion";
import { Activity, Eye, Users2 } from "lucide-react";
import { useLiveStats } from "@/lib/tracking";
import { useT } from "@/lib/i18n";

export default function LiveStatsWidget({ variant = "dark", compact = false }) {
    const stats = useLiveStats(15000);
    const { t } = useT();
    const dark = variant === "dark";

    if (!stats) return null;

    const items = [
        {
            key: "active",
            icon: Activity,
            value: stats.active_users,
            label: t("live.activeUsers"),
            pulse: stats.active_users > 0,
        },
        {
            key: "visits",
            icon: Eye,
            value: stats.total_visits,
            label: t("live.totalVisits"),
        },
        {
            key: "unique",
            icon: Users2,
            value: stats.unique_visitors,
            label: t("live.uniqueVisitors"),
        },
    ];

    return (
        <div
            data-testid="live-stats-widget"
            className={`inline-flex flex-wrap items-center gap-2 ${compact ? "" : "gap-3"}`}
        >
            {items.map((it) => (
                <motion.div
                    key={it.key}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    data-testid={`live-stat-${it.key}`}
                    className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium ${
                        dark
                            ? "bg-white/12 backdrop-blur-md border border-white/20 text-white"
                            : "bg-white border border-black/8 text-ink-primary"
                    }`}
                >
                    <span className="relative inline-flex items-center justify-center">
                        <it.icon size={13} strokeWidth={1.8} />
                        {it.pulse && (
                            <span className="absolute -right-1 -top-1 inline-flex h-2 w-2 rounded-full bg-emerald-400 ring-2 ring-emerald-400/40 animate-pulse" />
                        )}
                    </span>
                    <span className={`font-mono tabular-nums ${dark ? "text-white" : "text-brand-blue"}`}>
                        {it.value.toLocaleString()}
                    </span>
                    <span className={`text-[10px] uppercase tracking-[0.18em] ${dark ? "text-white/70" : "text-ink-muted"}`}>
                        {it.label}
                    </span>
                </motion.div>
            ))}
        </div>
    );
}
